import { render, staticRenderFns } from "./Bias.vue?vue&type=template&id=1f7a7687&scoped=true&"
import script from "./Bias.vue?vue&type=script&lang=js&"
export * from "./Bias.vue?vue&type=script&lang=js&"
import style0 from "./Bias.vue?vue&type=style&index=0&id=1f7a7687&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7a7687",
  null
  
)

export default component.exports